import { Component, Input } from '@angular/core';
import { NavigationExtras } from '@angular/router';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { InnogyComponentRendering } from '@core/jss-models';
import {
  GenericLinkDirective,
  InterpolationOptions,
  TextInterpolationPipe,
} from '@core/jss-utils';
import type { RichTextField } from '@sitecore-jss/sitecore-jss-angular';
import {
  JssModule,
  LinkField,
  TextField,
} from '@sitecore-jss/sitecore-jss-angular';
import {
  TrackImpressionDirective,
  TrackLinkDirective,
} from '@analytics/events';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgClass } from '@angular/common';
import { CardComponent } from '@legacy/common-ui-partials';

import { RichTextWrapperComponent } from '../rich-text-wrapper/rich-text-wrapper.component';

@Component({
  selector: 'wl-information-block',
  templateUrl: './information-block.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    TrackImpressionDirective,
    AutomationIdDirective,
    FaIconComponent,
    JssModule,
    RichTextWrapperComponent,
    NgClass,
    GenericLinkDirective,
    TrackLinkDirective,
    TextInterpolationPipe,
    CardComponent,
  ],
})
export class InformationBlockComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) rendering: InnogyComponentRendering | undefined;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() title?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() message?: TextField | RichTextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() interpolationOptions?: InterpolationOptions;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() link?: LinkField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() linkSecondary?: LinkField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() linedTitle = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() sideNote = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() buttonType: 'button' | 'link' = 'link';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() icon?: IconProp;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() navigationExtras: NavigationExtras = {
    queryParamsHandling: 'merge',
  };
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() automationId = 'information-block';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() trackImpressionName?: string;
}
